import { Spin } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { menuItemsApi } from '../../../api/menuItems';
import { TTMenuItem } from '../../../interfaces/menuItem';
import { TTOrderItem, TTOrderItemCreate } from '../../../interfaces/order_item';
import { LoadingIcon } from '../../components/Spinner';
import { centsToDollars } from '../../utils';

type Props = {
  orderItem: TTOrderItem | TTOrderItemCreate;
};

export function SubscriptionDisplayInfo({ orderItem }: Props) {
  const [loading, setLoading] = useState(false);
  const [menuItem, setMenuItem] = useState<TTMenuItem | null>(null);
  const fetchItem = async () => {
    try {
      setLoading(true);
      const item = await menuItemsApi.getMenuItem(orderItem?.menu_item_id);
      setMenuItem(item.data);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItem();
  }, [orderItem?.cart_insert_ts]);

  const subscriptionInfo = orderItem
    ? 'id' in orderItem
      ? orderItem.subscription_info
      : orderItem.subscription_request
    : null;
  const subscriptionPriceObject = subscriptionInfo
    ? 'id' in subscriptionInfo
      ? menuItem?.subscription_product?.prices?.filter(p =>
          subscriptionInfo?.price_ids?.includes(p.price_id ?? 'test'),
        )
      : 'menu_item_id' in subscriptionInfo
      ? menuItem?.subscription_product?.prices?.filter(p =>
          subscriptionInfo?.price_ids?.includes(p.id),
        )
      : null
    : null;
  const subscriptionPrice = subscriptionInfo?.price_data?.unit_amount;
  const subscriptionInterval =
    subscriptionInfo?.price_data?.recurring?.interval;
  const subscriptionIntervalCount =
    subscriptionInfo?.price_data?.recurring?.interval_count;
  console.log(subscriptionInfo);
  return (
    <>
      <Spin spinning={loading} indicator={LoadingIcon}>
        <div className="flex flex-col">
          {menuItem ? (
            <div className="flex flex-col">
              {subscriptionInfo &&
                (subscriptionInfo.is_custom_amount ? (
                  <div>
                    <p className="text-on-primary-container text-md ">
                      {centsToDollars(subscriptionPrice)} every{' '}
                      {subscriptionIntervalCount} {subscriptionInterval}
                      {subscriptionIntervalCount > 1 ? 's' : ''}
                    </p>
                  </div>
                ) : (
                  <>
                    {subscriptionPriceObject?.map(p => {
                      return (
                        <div key={p.id?.toString()}>
                          <p className="text-on-primary-container text-md ">
                            {centsToDollars(p.amount)} every {p.interval_count}{' '}
                            {p.interval}
                            {p.interval_count > 1 ? 's' : ''}
                          </p>
                        </div>
                      );
                    })}
                  </>
                ))}
              {'id' in orderItem ? (
                <div>
                  {orderItem?.subscription_info?.status === 'trialing' ? (
                    <div>
                      <div className="text-md text-on-primary-container">
                        Subscription Status:{' '}
                        <span className="font-semibold">Trialing</span>
                      </div>
                      <div className="text-md text-on-primary-container">
                        Trial ends:{' '}
                        <span className="font-semibold">
                          {moment
                            .unix(orderItem?.subscription_info?.trial_end_at)
                            ?.format('lll')}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {orderItem?.subscription_info?.cancel_at ? (
                    <div>
                      <div className="text-md text-on-primary-container">
                        Canceling subscription at:{' '}
                        <span className="font-semibold">
                          {moment
                            .unix(orderItem?.subscription_info?.cancel_at)
                            ?.format('lll')}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      </Spin>
    </>
  );
}
